export const SEND_INPUT = "chat/Sendinput";
export const GET_THREADS = "chat/Threads";
export const GET_THREAD_BY_ID = "chat/GetChat";
export const GET_THREAD_BY_UID = "chat/GetSharedChat";
export const GET_THREAD_BY_KUID = "chat/GetSharedChat/2";
export const DELETE_THREADS = "chat/DeleteThreads";
export const CHAT_FEEDBACK = "chat/feedback";
export const GET_PROFILE = "user/profile";
export const BULK_DELETE_THREADS = "history/delete";
export const GET_RECENT_HISTORY = "history/recent";
export const STOP_CHAT = "chat/stop";
